// extracted by mini-css-extract-plugin
export default {"component":"list_component__zpfIr","list":"list_list__LIOhM"};